import {
  UpdateVisualizationAccessPayload,
  VisualizationAccessProps,
} from "@/common/types";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useToast } from "@/hooks/use-toast";
import { updateVisualizationAccess } from "@/redux/actions/questionnaireAction";
import { useState } from "react";
import { useDispatch } from "react-redux";

const VisualizationAccess: React.FC<VisualizationAccessProps> = ({
  hasVisualizationAccess,
  doctorId,
  callback,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { toast } = useToast();

  const title = hasVisualizationAccess
    ? "Revoke Visualization Access"
    : "Grant Access to Report Visualization";

  const description = hasVisualizationAccess
    ? "Revoke Visualization Access for this user."
    : "Grant Visualization Access for this user.";

  const dispatch: any = useDispatch();

  const handleSubmit = () => {
    const payload: UpdateVisualizationAccessPayload = {
      doctor_id: doctorId as number,
      has_visualization_access: !hasVisualizationAccess,
    };
    dispatch(
      updateVisualizationAccess(payload, () => {
        setIsOpen(false);
        toast({
          title: "Visualization Access",
          description: hasVisualizationAccess ? "Revoked" : "Granted",
        });
        if (callback) {
          callback();
        }
      })
    );
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="secondary">{title}</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="submit" onClick={() => handleSubmit()}>
            {title}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default VisualizationAccess;
